export enum ReceivableDocumentType {
  INVOICE_FROM_PLATFORM = "INVOICE_FROM_PLATFORM",
  EXCHANGE_CONTRACT = "EXCHANGE_CONTRACT",
  INVOICE = "INVOICE",
  NF_E = "NF_E",
}

export const RECEIVABLE_DOCUMENT_TYPE_LABELS: Record<ReceivableDocumentType, string> = {
  [ReceivableDocumentType.INVOICE_FROM_PLATFORM]: "Nota fiscal da plataforma",
  [ReceivableDocumentType.EXCHANGE_CONTRACT]: "Contrato de câmbio",
  [ReceivableDocumentType.INVOICE]: "Nota fiscal",
  [ReceivableDocumentType.NF_E]: "NF-e",
};

export interface ReceivableDocument {
  id: string;
  receivableId: string;
  documentUrl: string;
  documentType: ReceivableDocumentType;
  description?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt?: string;
  file?: File;
}

export interface CreateReceivableDocumentPayload {
  receivableId: string;
  documentType: ReceivableDocumentType;
  description?: string;
  file?: File;
  documentUrl?: string;
}

/** Resposta do POST que solicita URL pré-assinada (fluxo em 2 etapas) */
export interface CreateReceivableDocumentApiResponse {
  documentId: string;
  signedUploadUrl: string;
  path: string;
  token: string;
  publicUrl: string;
  documentType: ReceivableDocumentType;
  description?: string | null;
}

export interface UpdateReceivableDocumentPayload {
  id: string;
  receivableId?: string;
  documentType?: ReceivableDocumentType;
  description?: string;
  file?: File;
  documentUrl?: string;
}

export interface PendingReceivableDocument {
  id: string;
  documentType: ReceivableDocumentType;
  description?: string;
  documentUrl?: string;
  file?: File;
  createdAt: string;
  updatedAt?: string;
}

